import React, {useState} from "react";
import {db, doSignInWithEmailAndPassword} from "../../../components/Firebase/Firebase";
import {useAuth} from "../../../components/context/authContext/AuthContext";
import {Navigate} from "react-router-dom";
import {useLoading} from "../../../components/context/LoadingContext";
import { query, collection, where, getDocs } from 'firebase/firestore';
import logo from '../../../assets/images/logo.svg'
import './LoginPage.css'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {IconButton, InputAdornment} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

const LoginPage = () => {
    const { userLoggedIn } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useLoading(false);

    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSigningIn) {
            setIsLoading(true);
            setIsSigningIn(true);

            try {
                console.log(password, email)
                const adminQuery = query(collection(db, "admin"), where("email", "==", email));
                const querySnapshot = await getDocs(adminQuery);

                if (querySnapshot.empty) {
                    throw new Error();
                }

                await doSignInWithEmailAndPassword(email, password);
            } catch (err) {
                setError("Неверное имя пользователя или пароль");
                setIsLoading(false);
                setIsSigningIn(false);
                return;
            }

            setIsLoading(false);
        }
    };

    return (
        <section className="loginSection">
            {userLoggedIn && <Navigate to={'/'} replace={true} />}
            <div className="loginBox">
                <div className="loginLogo text-center">
                    <img src={logo} alt="logo"/>
                    <span className="ml-2">Admin</span>
                </div>
                <form onSubmit={handleSubmit} className="loginForm">
                    <TextField
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        label="Email"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                    />
                    <TextField
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        label="Пароль"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#CEFC4C',
                                },
                                '& input': {
                                    color: '#fff',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#fff',
                                '&.Mui-focused': {
                                    color: '#fff',
                                },
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff className='eyeIcon'/> : <Visibility className='eyeIcon'/>}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {error && <div className="error">{error}</div>}
                    <Button
                        className='logInButton'
                        type="submit"
                        variant="contained"
                        fullWidth
                    >
                        Войти
                    </Button>
                </form>
            </div>
        </section>
    );
};

export default LoginPage